import { STANDARD_BRANCH } from '@festina-life/api'

import { DraftIndicator } from '../../components/draftIndicator/DraftIndicator'
import { OperationApproval } from '../../components/operationApproval/OperationApproval'
import { OperationViewerTopBar } from '../../components/operationViewerTopBar/OperationViewerTopBar'
import { useIsInlineEditingAvailable } from '../../hooks/useIsInlineEditingAvailable'
import { useNavigationParams } from '../../system/useNavigationParams'
import type { IndexedReconciliationSpecOperationWithMetaData } from '../../uiModels/reconciliationSpecOperations/types'
import { ReconciliationSpecDownloadVersionButton } from './ReconciliationSpecDownloadVersionButton'
import { ReconciliationSpecTransferButton } from './ReconciliationSpecTransferButton'
import { ReconciliationSpecUploadVersionButton } from './ReconciliationSpecUploadVersionButton'

type Props = {
  /** Version in scope, if any exists at the current view date. */
  reconciliationSpecOperation: IndexedReconciliationSpecOperationWithMetaData
}

/**
 * TopBar used to identify the reconciliation-spec version in scope and to host its
 * operation management controls, such as approval, download, upload and transfer.
 */
export const ReconciliationSpecViewerTopBar = ({
  reconciliationSpecOperation,
}: Props) => {
  const isInlineEditingAvailable = useIsInlineEditingAvailable()
  const { branch } = useNavigationParams()
  const changesetKey =
    reconciliationSpecOperation.changesetHistory?.changesetKey
  const operationKey =
    reconciliationSpecOperation.internalOperation.operationKey
  const isRenderingApproval =
    !reconciliationSpecOperation.isDraft &&
    branch !== STANDARD_BRANCH &&
    !!changesetKey &&
    !!operationKey

  return (
    <OperationViewerTopBar className="justify-end gap-x-2">
      {reconciliationSpecOperation.isDraft && <DraftIndicator />}
      {isRenderingApproval && (
        <OperationApproval
          actions={reconciliationSpecOperation.actions ?? []}
          changesetKey={changesetKey}
          operationKey={operationKey}
        />
      )}
      <ReconciliationSpecDownloadVersionButton
        reconciliationSpecOperation={reconciliationSpecOperation}
      />
      {isInlineEditingAvailable && <ReconciliationSpecUploadVersionButton />}
      <ReconciliationSpecTransferButton />
    </OperationViewerTopBar>
  )
}
